import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    status: '',
    token: localStorage.getItem('auth_token') || '',
  },
  mutations: {
    setAuthResult (state, data) {
      if (data.access_token) {
        state.token = data.access_token
        localStorage.setItem('auth_token', data.access_token)
      }
    },
  },
  actions: {
    setAuthResult ({ commit }, data) {
      commit('setAuthResult', data)
    }
  },
  getters: {
    
  },
	plugins: [
		createPersistedState({ storage: window.sessionStorage })
	]
})
